export function arrayToKeyedObject<T extends Record<string, unknown>>(
  array: unknown,
  keyField: keyof T
): Record<string, T> {
  // Input validation

  if (!Array.isArray(array)) {
    throw new Error(`arrayToKeyedObject: Expected array but received ${typeof array}`);
  }

  if (!keyField || typeof keyField !== "string") {
    throw new Error(`arrayToKeyedObject: keyField must be a valid string, received: ${String(keyField)}`);
  }

  if (array.length === 0) {
    console.warn("arrayToKeyedObject: Empty array provided, returning null to allow clean fallbacks");
    return null;
  }

  const result: Record<string, T> = {};
  const errors: string[] = [];

  array.forEach((item, index) => {
    // Check if item is an object
    if (!item || typeof item !== "object") {
      errors.push(`Item at index ${index} is not an object: ${typeof item}`);
      return;
    }

    // Check if keyField exists on the item
    if (!(keyField in item)) {
      errors.push(
        `Item at index ${index} missing key field "${String(keyField)}". Available keys: [${Object.keys(item).join(
          ", "
        )}]`
      );
      return;
    }

    const key = item[keyField];

    // Check if key value is valid
    if (key === undefined || key === null || key === "") {
      errors.push(`Item at index ${index} has invalid key value: ${key} (type: ${typeof key})`);
      return;
    }

    const stringKey = String(key);

    // Check for duplicate keys
    if (stringKey in result) {
      console.warn(
        `arrayToKeyedObject: Duplicate key "${stringKey}" found at index ${index}. Overwriting previous value.`
      );
    }

    result[stringKey] = item;
  });

  // Report all errors if any found
  if (errors.length > 0) {
    const errorMessage = `arrayToKeyedObject failed with ${errors.length} error(s):\n${errors.join("\n")}`;
    throw new Error(errorMessage);
  }

  return result;
}
